import { Card, CardBody, Col, Row } from "reactstrap";
import { IconsBodyProps } from "../../../Types/IconsType";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { IconsTitle } from "../../../Constants/Constants";

export const FontAwesomeBody:React.FC<IconsBodyProps> = ({ title, iconType, parentCallback }) => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={`${title} ${IconsTitle} `} />
        <CardBody>
          <Row className="icon-lists">
            {iconType.map((icon, i) => (
              <Col sm="6" md="4" xl="3" key={i} onClick={() => parentCallback(icon)}>
                <i className={`fa fa-${icon}`}></i> {"fa fa-"}
                {icon}
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
